

var _cardMetaData = require('../cardMetaData');

var _logger = require('xo-beaver/dist/logger');

var _choice = require('xo-models/src/choice');

define(['angular', 'squid/module', 'text!./template.html', 'jquery', 'components/xo-models/src/checkout/index', 'components/xo-models/src/auth/index', 'components/xo-models/src/fi/index', '../creditcard-input/directive', 'components/xo-ui-components/src/dropdown/directive', 'components/xo-tray-height/dist/directive', 'components/xo-page-components/src/aside-header/directive', 'components/xo-ui-components/src/message/directive', 'components/xo-ui-components/src/error-tooltip/directive', 'components/angular-ui-utils/ui-utils.min', 'components/xo-ui-components/src/accessibility/directive', '../../fi-contingency-list/util'], function (angular, module, template, $) {

    return module('xo-add-card.addcard.directive', ['squid', 'xomodel.checkout', 'xomodel.auth', 'xomodel.fi', 'xo-add-card.creditcard-input.directive', 'xo-dropdown.directive', 'xo-tray-height.directive', 'xo-aside-header.directive', 'xo-message.directive', 'xo-error-tooltip.directive', 'ui.validate', 'xo-accessibility.directive', 'fi.errorUtil']).directive('xoAddCard', function () {

        return {
            template: template,

            scope: {
                token: '=',
                done: '=',
                messagetitle: '=',
                message: '=',
                pagetitle: '=',
                sidebar: '=',
                showmeftsection: '=',
                hideparenthead: '=',
                billingaddressupdated: '=',
                cardmodel: '=',
                parentCallbacks: '=',
                selectedPromotionCardType: '=',
                promotion: '=',
                pageLevel: '=',
                logout: '=',
                phone: '=',
                manageCardFlow: '=',
                showCancel: '=',
                showSetPreferredFi: '=',
                onSuccess: '='
            },
            controller: function controller($scope, $populate, $state, $stateParams, $BillingAddressesModel, $CardTypesModel, $CheckoutSessionModel, $AuthModel, $CheckoutCartModel, $timeout, $element, $rootScope, $locale, $util, $config, $ResolveOTP, $Class, $fiErrorUtil, $renderContent, $meta, $FlowEligibilityModel, $q, $PreferredFi) {

                $populate($scope, {
                    cart: $CheckoutCartModel.instance($scope.token),
                    auth: $AuthModel.instance(),
                    billingAddresses: $BillingAddressesModel.instance(),
                    checkoutSession: $CheckoutSessionModel.instance($scope.token).retrieve({
                        contingencies: {
                            NEED_CREDIT_CARD: angular.noop,
                            EXPIRED_CREDIT_CARD: angular.noop
                        }
                    }),
                    flowEligibility: $FlowEligibilityModel.instance($scope.token).retrieve({
                        params: {
                            geolocation: $meta.geolocation,
                            localeCountry: $locale.country
                        }
                    })
                }).then(function () {
                    return _choice.$ChoiceEligibility.instance().getVariant($scope.token).then(function (variant) {
                        var multipleFiVariants = $config.choiceExperiment && $config.choiceExperiment.multipleFi || [];

                        if (multipleFiVariants.indexOf(variant) !== -1) {
                            $scope.showMultipleFI = true;
                        }
                    });
                }).then(function () {
                    if ($scope.cart.isWalletTokenization()) {
                        _logger.$logger.info('tokenized_wallet', {
                            'from': 'ADD_DEBIT_CARD',
                            'to': 'prepare_ADD_DEBIT_CARD',
                            'context_id': $scope.token,
                            'context_type': 'BA-Token',
                            'ba_token': $meta.baToken
                        });
                    }

                    $scope.debitCardFlow = angular.isArray($scope.flowEligibility.paymentCardProductClass) && $scope.flowEligibility.paymentCardProductClass.length === 1 && $scope.flowEligibility.paymentCardProductClass[0] === 'DEBIT';

                    if ($scope.showmeftsection) {
                        $scope.showmeftsection.toggle = true;
                    }

                    if ($scope.hideparenthead) {
                        $scope.hideparenthead.toggle = false;
                    }

                    $scope.manageCardFlow = $scope.sidebar && $scope.cardmodel.card.isExisting();

                    var type = $scope.selectedPromotionCardType && $scope.selectedPromotionCardType.type;

                    if ($scope.checkoutSession.plccOffer && !type && $scope.promotion) {
                        $state.go('^.selectCard');
                    }

                    $scope.showplcc = type === 'plcc';
                    $scope.country = $locale.country;

                    $scope.showNotYou = $scope.auth.is_auth_api_call && $util.param('source') !== 'consumerApp' && $scope.logout;

                    $scope.showHiMsg = Boolean($scope.messagetitle);

                    $scope.cardmodel.cardType = 'creditCard';

                    if ($scope.checkoutSession.plccOffer && $scope.showplcc) {
                        $scope.cardmodel.cardType = 'privateLabel';
                        $scope.cardmodel.sponsor_id = $scope.checkoutSession.plccOffer.sponsor_id;
                    }

                    $scope.cardmodel.user = {
                        first_name: $scope.auth.first_name,
                        last_name: $scope.auth.last_name
                    };

                    $scope.cardmodel.address = $scope.billingAddresses.addresses[0];

                    if ($scope.billingaddressupdated.value) {
                        $scope.billingaddressupdated = {
                            msgs: [$locale.content.get('editCard.newAddressAdded')],
                            type: 'success',
                            value: true
                        };
                    }

                    $scope.gotoBilling = function (address) {
                        if ($scope.pageLevel) {
                            $scope.pageLevel.message = null;
                        }
                        if (!address) {
                            if ($locale.country === 'BR') {
                                $scope.parentCallbacks.showCep();
                            } else {
                                // page transition
                                var el = $('.tokenization #sidepageAddCard');
                                if (el) {
                                    el.addClass('slideLeft');
                                }
                                $state.go('^.addBilling');
                            }
                        }
                    };

                    $scope.isCUP = function () {
                        return $scope.cardmodel.card && $scope.cardmodel.card.type && $scope.cardmodel.card.type === 'CUP';
                    };

                    $scope.isUpdateDebitCard = function () {
                        return $stateParams.message === 'EXPIRED_DEBIT_CARD';
                    };

                    $scope.flag = function (field) {
                        return _cardMetaData.$CardMetaData.getMetaData($scope.cardmodel.card, field);
                    };

                    $scope.buttonText = function () {
                        if ($scope.debitCardFlow) {
                            return 'creditcard.saveBtn';
                        }

                        var contentString = 'creditcard.addBtn';
                        if ($scope.cardmodel.card.isExisting()) {
                            contentString = 'creditcard.updateBtn';
                        } else if ($scope.isCUP()) {
                            contentString = 'creditcard.continuetext';
                        }
                        return contentString;
                    };

                    $scope.cardTypeChanged = function () {
                        $scope.phone.phoneType = $scope.flag('phoneType');
                    };

                    function addErrorMessage(contentKey) {
                        if (contentKey) {
                            contentKey = angular.isArray(contentKey) ? contentKey[0] : contentKey;
                            var message = $locale.content.get('creditcard.' + contentKey);
                            $scope.message.msgs.push(message);
                        }
                    }

                    function handleContingencies(result, contentBundle, defaultErrorKey, prop) {
                        var errorData;

                        if (result.errorCodes) {
                            errorData = result;
                        } else {
                            errorData = {
                                errorCodes: result && [result['0']]
                            };
                        }
                        $scope.message = $fiErrorUtil.addPageErrors(errorData, contentBundle, prop, defaultErrorKey);

                        if (window.scrollTo) {
                            window.scrollTo(0, 0);
                        }
                    }

                    $scope.cancelFn = function () {
                        // Use callback provided by parent route if there
                        if ($scope.parentCallbacks.cancel) {
                            return $scope.parentCallbacks.cancel();
                        }

                        // For multiple FI variant, route back to review page
                        if ($scope.showMultipleFI) {
                            if ($scope.manageCardFlow) {
                                return $state.go('checkout.review.sidebar.sidebarManageWallet');
                            }
                            return $state.go('checkout.review');
                        }

                        if ($scope.sidebar) {
                            if (!$scope.checkoutSession.plccOffer) {
                                return $state.go('checkout.review.sidebar.wallet');
                            } else {
                                return $state.go('^.selectCard');
                            }
                        }

                        $scope.done();
                    };

                    function initiateOTP() {
                        var resolveOTP = new $ResolveOTP({ id: $scope.cardmodel.id });
                        resolveOTP.action('init', {
                            data: {
                                phone: {
                                    country_code: $scope.phone.IntDialingCountryCode,
                                    number: $scope.phone.telephone
                                }
                            },
                            resultModel: {},
                            success: function success() {
                                $state.go('.confirmUpop');
                            },

                            error: function error() {
                                handleContingencies({}, 'confirmUpop', 'declineMessage');
                            },

                            contingencies: {
                                INIT_OTP_CONTINGENCY: function INIT_OTP_CONTINGENCY(name, result) {
                                    // prop for last 4 digits of card in error message
                                    var prop = {
                                        number: $scope.cardmodel && $scope.cardmodel.card && $scope.cardmodel.card.last4()
                                    };

                                    handleContingencies(result, 'confirmUpop', 'declineMessage', prop);
                                    $fiErrorUtil.addFieldErrors(result, $element);
                                },
                                DEFAULT: function DEFAULT() {
                                    handleContingencies({}, 'confirmUpop', 'declineMessage');
                                }
                            }
                        });
                    }

                    function handleCheckoutSession(result, isNewCard) {
                        if ($scope.cardmodel && $scope.cardmodel.cardType === 'privateLabel') {
                            delete $scope.checkoutSession.plccOffer;
                        }

                        delete $scope.checkoutSession.errorData;

                        var cardAdded = $scope.cardmodel && $scope.cardmodel.card;
                        var numberAdded;
                        var cardTypeAdded;

                        if (cardAdded) {
                            numberAdded = angular.isString(cardAdded.number) && cardAdded.number.replace(/\s/g, '');
                            cardTypeAdded = cardAdded.type;
                        }

                        var last4Added = angular.isString(numberAdded) && numberAdded.substr(numberAdded.length - 4);
                        var cvvData = $scope.checkoutSession.cvvData;
                        var last4ToUse;
                        var cardTypeToUse;

                        if (cvvData) {
                            last4ToUse = cvvData.number;
                            cardTypeToUse = cvvData.type;
                        }

                        if (last4ToUse === last4Added && cardTypeAdded === cardTypeToUse) {
                            $scope.checkoutSession.set('cvvData.security_code', $scope.cardmodel.get('card.security_code'));

                            $scope.checkoutSession.set('cvvData.lastAddedCard', true);
                        }

                        var updateCardSidebarMessage = $renderContent('wallet.cardUpdated', {
                            type: cardTypeAdded,
                            number: last4Added
                        });
                        var updateCardPageMessage = $renderContent('smallToolTip.cardUpdated');
                        var addCardMessage = $renderContent('smallToolTip.cardAdded');

                        var msgs = [addCardMessage];

                        if (!isNewCard) {
                            msgs = $scope.manageCardFlow ? [updateCardSidebarMessage] : [updateCardPageMessage];
                        }

                        $scope.checkoutSession.message = {
                            type: 'success',
                            msgs: msgs
                        };

                        $scope.done();
                    }

                    $scope.onSubmit = function () {
                        if ($scope.pageLevel) {
                            $scope.pageLevel.message = null;
                        }
                        var isNewCard = !$scope.cardmodel.card.isExisting();

                        if (isNewCard) {
                            delete $scope.cardmodel.id;
                        }

                        if ($('#plccAgree').is(':checked')) {
                            $scope.cardmodel.preference = true;
                        }

                        // Only initiateOTP needs to be called for unconfirmed CUP contingency. Add card call does not need to be made.
                        if ($scope.isCUP() && $scope.cardmodel.id && ($scope.checkoutSession.get('errorData.cause') === 'NEED_AUTHENTICATED_CARD' || $scope.checkoutSession.get('errorData.cause') === 'EXPIRED_CREDIT_CARD')) {

                            initiateOTP();
                        } else {
                            $scope.cardmodel.save({

                                success: function success() {
                                    if ($scope.isCUP()) {
                                        initiateOTP();
                                    } else if ($scope.cart.isWalletTokenization()) {
                                        var fpti_payload = {
                                            'from': 'ADD_DEBIT_CARD',
                                            'to': 'process_ADD_debit_card',
                                            'context_id': $scope.token,
                                            'context_type': 'BA-Token',
                                            'ba_token': $meta.baToken
                                        };
                                        $scope.checkoutSession.fundingOptions.action('notifyChange', {
                                            resultModel: $scope.checkoutSession,

                                            data: {
                                                planId: $scope.cardmodel.id,
                                                operation: 'ADDED'
                                            },

                                            success: function success(result) {
                                                _logger.$logger.info('tokenized_wallet', fpti_payload);
                                                handleCheckoutSession(result, isNewCard);
                                            },

                                            contingencies: {
                                                TRANSACTION_REFUSED: function TRANSACTION_REFUSED(name) {
                                                    fpti_payload.int_error_desc = 'TRANSACTION_REFUSED_addedButCannotUse';
                                                    fpti_payload.error_source = 'ppas';
                                                    _logger.$logger.info('tokenized_wallet', fpti_payload);
                                                    $scope.message.msgs = [];
                                                    $scope.message.type = 'info';
                                                    addErrorMessage('addedButCannotUse');
                                                }
                                            }
                                        });
                                    } else {
                                        return $q.when().then(function () {
                                            // setPreferredFI checkbox is checked
                                            if ($scope.showSetPreferredFi && $('#makeFiPreferred').is(':checked')) {

                                                _logger.$logger.info('set_preferredFI_checked');

                                                // set preferred FI before updating
                                                var preferredFi = new $PreferredFi({
                                                    preferred: [$scope.cardmodel.id]
                                                });

                                                return preferredFi.save({
                                                    success: function success() {
                                                        _logger.$logger.info('SET_PREFERREDFI_SUCCESS', { preferred: [$scope.cardmodel.id] });
                                                    },
                                                    transientError: true,
                                                    error: function error(err) {
                                                        // log the error but fails silently because card is added
                                                        _logger.$logger.error('SET_PREFERREDFI_ERROR', { error: err });
                                                    },
                                                    contingencies: {
                                                        DEFAULT: function DEFAULT(name, contingency) {
                                                            _logger.$logger.info('SET_PREFERREDFI_CONTINGENCY', name);
                                                        }
                                                    }
                                                });
                                            }
                                        }).then(function () {
                                            return $scope.checkoutSession.fundingOptions.action('update', {

                                                resultModel: $scope.checkoutSession,

                                                data: {
                                                    planId: $scope.cardmodel.id
                                                },

                                                success: function success(result) {
                                                    handleCheckoutSession(result, isNewCard);
                                                },

                                                contingencies: {
                                                    TRANSACTION_REFUSED: function TRANSACTION_REFUSED(name) {
                                                        $scope.message.msgs = [];
                                                        $scope.message.type = 'info';
                                                        addErrorMessage('addedButCannotUse');
                                                    }
                                                }
                                            });
                                        });
                                    }
                                },

                                contingencies: {
                                    ADD_CARD_CONTINGENCY: function ADD_CARD_CONTINGENCY(name, result) {
                                        if ($scope.sidebar) {
                                            $scope.$emit('SidebarError');
                                        }
                                        $scope.billingaddressupdated.value = false;
                                        if (result && result.errorCodes) {
                                            handleContingencies(result, 'creditcard', 'errorInvalidData');
                                            $fiErrorUtil.addFieldErrors(result, $element);
                                        } else if (result && result['0']) {
                                            handleContingencies(result, 'creditcard');
                                        } else {
                                            handleContingencies({}, 'creditcard', 'errorInternalError');
                                        }
                                    },
                                    DISALLOWED_CUPSECURE_ADDITION: function DISALLOWED_CUPSECURE_ADDITION(name, result) {
                                        handleContingencies({}, 'creditcard', 'errorInternalError');
                                    },
                                    VALIDATION_ERROR: function VALIDATION_ERROR(name, result) {
                                        var $field = $($element).find('[ng-model="card.number"]');
                                        $field.addClass('backendError');
                                        $field.attr('aria-invalid', true);
                                        $field.focus();
                                    },
                                    DEFAULT: function DEFAULT(name, result) {
                                        handleContingencies({ errorCodes: [name] }, 'creditcard', 'errorInternalError');
                                    }

                                },

                                error: function error() {
                                    handleContingencies({}, 'creditcard', 'errorInternalError');
                                },

                                validation: function validation(res) {}
                            });
                        }
                    };
                });
            }
        };
    });
});

_cardMetaData.$CardMetaData;

_logger.$logger;

_choice.$ChoiceEligibility;


//////////////////
// WEBPACK FOOTER
// ./components/xo-wallet-components/src/add-card/addcard/directive.js
// module id = ./components/xo-wallet-components/src/add-card/addcard/directive.js
// module chunks = 1